
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}:host{color:var(--color-font-content);display:block}.desktop-wrapper{-moz-column-gap:var(--gap-2lg);column-gap:var(--gap-2lg);display:grid;grid-template-columns:1fr 2fr}.content-wrapper{display:flex;flex-direction:column;gap:var(--gap-2lg)}.mobile-wrapper .icon-group{padding-top:var(--spacing-4)}.mobile-wrapper .cta{display:flex;justify-content:center;padding-top:var(--spacing-8)}`;